import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksExecutors: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
	},
	getOrderGeneratorsFieldsWorksExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
	},
	createOrderGeneratorsFieldsWorksExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
	},
	createOrderGeneratorsFieldsWorksExecutorBulk: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR_BULK,
	},
	putOrderGeneratorsFieldsWorksExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
	},
	patchOrderGeneratorsFieldsWorksExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
	},
	deleteOrderGeneratorsFieldsWorksExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR,
	},
}
